import {
  Button,
  HStack,
  Icon,
  SimpleGrid,
  Box,
  Tag,
} from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useBackRef from '../../../../../../../common/src/hooks/query-params/useBackRef';
import { useFlowsSelector } from '../../../../../../../common/src/utils/globalVariables';
import PreviewModeTooltip from './PreviewModeTooltip';
import ViewOnlyModeActionMenu from './ViewOnlyModeActionMenu';
import ViewOnlyModeTooltip from './ViewOnlyModeTooltip';

const ViewOnlyModeHeader: React.FC = () => {
  const { t } = useTranslation();
  const backRef = useBackRef();
  const isPreviewModeOn = useFlowsSelector(
    (state) => state.flows.isPreviewModeOn,
  );

  return (
    <SimpleGrid
      templateColumns="1fr auto 1fr"
      w="100%"
      py="3"
      px="2"
      borderBottom="gray.50"
      boxShadow="level1"
    >
      <Button
        as={Link}
        to={backRef || '/dashboard'}
        variant="grayedGhost"
        size="sm"
        leftIcon={<Icon name="GeneralActionsArrowLeft" />}
        justifySelf="flex-start"
      >
        {t('FLOWS_COMPANY-SCAN_VIEW-ONLY-HEADER_BACK-BUTTON')}
      </Button>
      <HStack justify="center" spacing="0" flexGrow={1}>
        {isPreviewModeOn ? (
          <Tag>
            {t('FLOWS_COMPANY-SCAN_PREVIEW-HEADER_TITLE')}
            <PreviewModeTooltip />
          </Tag>
        ) : (
          <Tag>
            {t('FLOWS_COMPANY-SCAN_VIEW-ONLY-HEADER_TITLE')}
            <ViewOnlyModeTooltip />
          </Tag>
        )}
      </HStack>
      <Box justifySelf="flex-end">
        <ViewOnlyModeActionMenu />
      </Box>
    </SimpleGrid>
  );
};

export default ViewOnlyModeHeader;
